<div appPreventCopy>
  <!-- Title -->
  <h2 *ngIf="title" class="title">{{ title }}</h2>

  <div class="wrapper" [ngClass]="variant">
    <!-- Section -->
    <div *ngFor="let categoryParent of categories; trackBy: trackByUuid" class="section-wrapper">
      <span class="section-title">{{ categoryParent.shortName }}</span>

      <div class="cards">
        <a
          *ngFor="let category of categoryParent.categories; trackBy: trackByUuid"
          [routerLink]="links.recommendationsDetail(category.uuid)"
          class="card-content"
          [style.background]="colorService.mixWithWhite(categoryParent.color, 0.25)"
        >
          <span *ngIf="category | competenceNumber as number" class="competence-number">{{ number }}</span>
          <div class="text-wrapper">
            <span
              ><strong>{{ category.name }}</strong></span
            >
            <span *ngIf="category.shortName">({{ category.shortName }})</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
